import { IS_PRODUCTION_DEPLOYMENT } from '@soundxyz/utils/constants/env';
import { isMainSoundxyzSite } from '@utils/constants';

/**
 * Show React Query dev tools unless we're in prod
 *
 * Next.js + Webpack doesn't work properly behind conditional top level await,
 * and to be safe we just make an extra promise around the null without going into importing the library
 */
export const ReactQueryDevTools = await (IS_PRODUCTION_DEPLOYMENT && isMainSoundxyzSite
  ? Promise.resolve(null)
  : import('@tanstack/react-query-devtools/build/lib/index.prod.js').then(
      value => value.ReactQueryDevtools,
    ));
